import { useTranslation } from 'react-i18next';
import './style.css';

const PatientProfileSummary = ({ admissionDetails }) => {
    const { t } = useTranslation();

    return (
        <div className="patient-profile-summary-section">
            <h2 className="patient-profile-summary-title">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px', verticalAlign: 'middle' }}>
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {t('patient-profile-summary')}
            </h2>

            {/* Medical Diagnosis / Primary Complaint */}
            <div className="patient-profile-summary-section-card">
                <h3 className="patient-profile-summary-section-title">{t('medical-diagnosis-primary-complaint')}</h3>
                <p className="patient-profile-summary-text">
                    {admissionDetails?.requestData?.medicalDiagnosis}
                </p>
            </div>

            {/* Height, Weight, Allergies */}
            <div className="patient-profile-summary-info-grid">
                <div className="patient-profile-summary-info-item">
                    <div className="patient-profile-summary-info-label">{t('height')}</div>
                    <div className="patient-profile-summary-info-value">{admissionDetails?.patientData?.height }</div>
                </div>
                <div className="patient-profile-summary-info-item">
                    <div className="patient-profile-summary-info-label">{t('weight')}</div>
                    <div className="patient-profile-summary-info-value">{admissionDetails?.patientData?.weight }</div>
                </div>
                <div className="patient-profile-summary-info-item">
                    <div className="patient-profile-summary-info-label patient-profile-summary-allergies-label">{t('allergies')}</div>
                    <div className="patient-profile-summary-info-value patient-profile-summary-allergies-value">
                        {admissionDetails?.patientData?.allergy}
                    </div>
                </div>
            </div>

            {/* Medical Family History */}
            <div className="patient-profile-summary-section-card">
                <h3 className="patient-profile-summary-section-title">{t('medical-family-history')}</h3>
                <p className="patient-profile-summary-text">
                    {admissionDetails?.patientData?.familyMedicalHistory}
                </p>
            </div>
        </div>
    );
};

export default PatientProfileSummary;

